import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['María López', 'Ana Martínez', 'Sofía Rodríguez', 'Laura Hernández', 'Carmen García', 'Isabella Pérez', 'Valentina Sánchez', 'Camila Gómez', 'Valeria Díaz', 'Mariana Torres'];
const CITIES = ['Miami, FL', 'Houston, TX', 'Los Angeles, CA', 'New York, NY', 'Chicago, IL', 'Dallas, TX', 'Phoenix, AZ', 'San Antonio, TX', 'San Diego, CA', 'Orlando, FL'];
export function PopNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  useEffect(() => {
    const showNotification = () => {
      setName(NAMES[Math.floor(Math.random() * NAMES.length)]);
      setCity(CITIES[Math.floor(Math.random() * CITIES.length)]);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimeout = setTimeout(showNotification, 3000);
    const interval = setInterval(showNotification, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-110">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -50
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-2xl border border-gray-100 p-3 flex items-center gap-3 max-w-sm" data-id="element-111">
          <img src="https://cdn.magicpatterns.com/uploads/wTK44LUP9MpFhkSSfKiSFh/Cover_de_Ebook_Landing.png" alt="Desconexión Emocional" className="w-14 h-14 rounded-lg object-cover shadow-sm" data-id="element-112" />
          <div className="flex flex-col" data-id="element-113">
            <p className="text-sm text-gray-800 leading-tight" data-id="element-114">
              <span className="font-bold" data-id="element-115">{name}</span>, {city} acaba de comprar{' '}
              <span className="font-bold italic" data-id="element-116">"Desconexión Emocional"</span>!
            </p>
            <p className="text-sm font-bold text-[#C41E3A] mt-1" data-id="element-117">en $6.99</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}